import { render, staticRenderFns } from "./RelationData.vue?vue&type=template&id=671c6188&scoped=true&"
import script from "./RelationData.vue?vue&type=script&lang=ts&"
export * from "./RelationData.vue?vue&type=script&lang=ts&"
import style0 from "./RelationData.vue?vue&type=style&index=0&id=671c6188&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c6188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
installComponents(component, {GCardIcon,VCard,VCardTitle,VDivider,VList,VListTile,VListTileContent})
